export enum FieldGroupTypeEnum {
  DSD = 'DSD',
  PSP = 'PSP',
  SRT = 'SRT',
  Specialty = 'Specialty',
}
